export default Object.freeze([
  { id: 'AAL', nome: 'Artur Alvim', sub: 7 },
  { id: 'ANH', nome: 'Anhanguera', sub: 31 },
  { id: 'API', nome: 'Alto de Pinheiros', sub: 22 },
  { id: 'ARA', nome: 'Agua Rasa', sub: 15 },
  { id: 'ARI', nome: 'Aricanduva', sub: 16 },
  { id: 'BEL', nome: 'Belem', sub: 15 },
  { id: 'BFU', nome: 'Barra Funda', sub: 13 },
  { id: 'BRE', nome: 'Bom Retiro', sub: 14 },
  { id: 'BRL', nome: 'Brasilandia', sub: 2 },
  { id: 'BRS', nome: 'Bras', sub: 15 },
  { id: 'BUT', nome: 'Butanta', sub: 21 },
  { id: 'BVI', nome: 'Bela Vista', sub: 14 },
  { id: 'CAC', nome: 'Cachoeirinha', sub: 3 },
  { id: 'CAD', nome: 'Cidade Ademar', sub: 26 },
  { id: 'CAR', nome: 'Carrao', sub: 16 },
  { id: 'CBE', nome: 'Campo Belo', sub: 29 },
  { id: 'CDU', nome: 'Cidade Dutra', sub: 25 },
  { id: 'CGR', nome: 'Campo Grande', sub: 29 },
  { id: 'CLD', nome: 'Cidade Lider', sub: 11 },
  { id: 'CLM', nome: 'Campo Limpo', sub: 23 },
  { id: 'CMB', nome: 'Cambuci', sub: 14 },
  { id: 'CNG', nome: 'Cangaiba', sub: 7 },
  { id: 'CON', nome: 'Consolacao', sub: 14 },
  { id: 'CRE', nome: 'Capao Redondo', sub: 23 },
  { id: 'CTI', nome: 'Cidade Tiradentes', sub: 30 },
  { id: 'CUR', nome: 'Cursino', sub: 19 },
  { id: 'CVE', nome: 'Casa Verde', sub: 3 },
  { id: 'ERM', nome: 'Ermelino Matarazzo', sub: 8 },
  { id: 'FRE', nome: 'Freguesia do O', sub: 2 },
  { id: 'GRA', nome: 'Grajau', sub: 25 },
  { id: 'GUA', nome: 'Guaianases', sub: 12 },
  { id: 'IBI', nome: 'Itaim Bibi', sub: 22 },
  { id: 'IGU', nome: 'Iguatemi', sub: 17 },
  { id: 'IPA', nome: 'Itaim Paulista', sub: 10 },
  { id: 'IPI', nome: 'Ipiranga', sub: 19 },
  { id: 'ITQ', nome: 'Itaquera', sub: 11 },
  { id: 'JAB', nome: 'Jabaquara', sub: 28 },
  { id: 'JAC', nome: 'Jacana', sub: 5 },
  { id: 'JAG', nome: 'Jaguara', sub: 13 },
  { id: 'JAR', nome: 'Jaragua', sub: 1 },
  { id: 'JBO', nome: 'Jose Bonifacio', sub: 11 },
  { id: 'JDA', nome: 'Jardim Angela', sub: 24 },
  { id: 'JDH', nome: 'Jardim Helena', sub: 9 },
  { id: 'JDP', nome: 'Jardim Paulista', sub: 22 },
  { id: 'JDS', nome: 'Jardim Sao Luis', sub: 24 },
  { id: 'JRE', nome: 'Jaguare', sub: 13 },
  { id: 'LAJ', nome: 'Lajeado', sub: 12 },
  { id: 'LAP', nome: 'Lapa', sub: 13 },
  { id: 'LIB', nome: 'Liberdade', sub: 14 },
  { id: 'LIM', nome: 'Limao', sub: 3 },
  { id: 'MAN', nome: 'Mandaqui', sub: 4 },
  { id: 'MAR', nome: 'Marsilac', sub: 27 },
  { id: 'MOE', nome: 'Moema', sub: 20 },
  { id: 'MOO', nome: 'Mooca', sub: 15 },
  { id: 'MOR', nome: 'Morumbi', sub: 21 },
  { id: 'PDR', nome: 'Pedreira', sub: 26 },
  { id: 'PEN', nome: 'Penha', sub: 7 },
  { id: 'PIN', nome: 'Pinheiros', sub: 22 },
  { id: 'PIR', nome: 'Pirituba', sub: 1 },
  { id: 'PLH', nome: 'Parelheiros', sub: 27 },
  { id: 'PQC', nome: 'Parque do Carmo', sub: 11 },
  { id: 'PRA', nome: 'Ponte Rasa', sub: 8 },
  { id: 'PRD', nome: 'Perdizes', sub: 13 },
  { id: 'PRI', nome: 'Pari', sub: 15 },
  { id: 'PRS', nome: 'Perus', sub: 31 },
  { id: 'REP', nome: 'Republica', sub: 14 },
  { id: 'RPE', nome: 'Rio Pequeno', sub: 21 },
  { id: 'RTA', nome: 'Raposo Tavares', sub: 21 },
  { id: 'SAC', nome: 'Sacoma', sub: 19 },
  { id: 'SAM', nome: 'Santo Amaro', sub: 29 },
  { id: 'SAP', nome: 'Sapopemba', sub: 32 },
  { id: 'SAU', nome: 'Saude', sub: 20 },
  { id: 'SCE', nome: 'Santa Cecilia', sub: 14 },
  { id: 'SDO', nome: 'Sao Domingos', sub: 1 },
  { id: 'SE', nome: 'Se', sub: 14 },
  { id: 'SLU', nome: 'Sao Lucas', sub: 18 },
  { id: 'SMI', nome: 'Sao Miguel', sub: 9 },
  { id: 'SMT', nome: 'Sao Mateus', sub: 17 },
  { id: 'SOC', nome: 'Socorro', sub: 25 },
  { id: 'SRA', nome: 'Sao Rafael', sub: 17 },
  { id: 'STN', nome: 'Santana', sub: 4 },
  { id: 'TAT', nome: 'Tatuape', sub: 15 },
  { id: 'TRE', nome: 'Tremembe', sub: 5 },
  { id: 'TUC', nome: 'Tucuruvi', sub: 4 },
  { id: 'VAN', nome: 'Vila Andrade', sub: 23 },
  { id: 'VCR', nome: 'Vila Curuca', sub: 10 },
  { id: 'VFO', nome: 'Vila Formosa', sub: 16 },
  { id: 'VGL', nome: 'Vila Guilherme', sub: 6 },
  { id: 'VJA', nome: 'Vila Jacui', sub: 9 },
  { id: 'VLE', nome: 'Vila Leopoldina', sub: 13 },
  { id: 'VMD', nome: 'Vila Medeiros', sub: 6 },
  { id: 'VMN', nome: 'Vila Mariana', sub: 20 },
  { id: 'VMR', nome: 'Vila Maria', sub: 6 },
  { id: 'VMT', nome: 'Vila Matilde', sub: 7 },
  { id: 'VPR', nome: 'Vila Prudente', sub: 18 },
  { id: 'VSO', nome: 'Vila Sonia', sub: 21 },
])
